export default {

  methods: {
    validationCheck: function(validationData, data){
      var ReturnValueErrors = []
      var rexMinLength = /minLength\[(\d+)\](.*)/gi;

      for (var validation in validationData){

        // Wenn es nicht aktiv ist dann wird es nicht beachtet
        if(typeof validationData[validation].activ != 'undefined' && validationData[validation].activ == false){
          continue;
        }
        
        // Hier wird die Länge des Feldinhalts überprüft
        var minLengthMatch = rexMinLength.exec(validationData[validation].type)
        if( minLengthMatch ){
          var minLength = minLengthMatch[1];
          
          if( typeof data[validation] != 'undefined' && data[validation].length >= minLength ){
            validationData[validation].class = ""
            if( minLengthMatch.length == 3 && 
                typeof validationData[validation].compareField != 'undefined' && 
                validationData[validation].compareField != '' &&
                minLengthMatch[2] === "password" ){
              if( data[validation] !== data[ validationData[validation].compareField ] ){
                validationData[validation].class = "error"
                ReturnValueErrors.push(validationData[validation].prompt2)
              }   
            }
          }
          else{
            validationData[validation].class = "error"
            ReturnValueErrors.push(validationData[validation].prompt)
          }
          continue;
        }

        // Hier wird ein Select Feld überprüft ob die ID größer 0 ist
        if( validationData[validation].type === 'selectionNot0' ){
          if( typeof data[validation] != 'undefined' && data[validation] > 0 ){
            validationData[validation].class = ""
          }
          else{
            validationData[validation].class = "error"
            ReturnValueErrors.push(validationData[validation].prompt)
          }
          continue;
        } 
        
        // Mittels einer Regex wird überprüft ob dies eine E-Mail Adresse ist
        var reEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if( validationData[validation].type === 'email' ){
          if( typeof data[validation] != 'undefined' && data[validation].length > 0 ){
            var emailValidate = data[validation].match(reEmail);
            if( emailValidate ){
              validationData[validation].class = ""
            }
            else{
              validationData[validation].class = "error"
              ReturnValueErrors.push(validationData[validation].prompt)
            }
          }
          else{
            validationData[validation].class = "error"
            ReturnValueErrors.push(validationData[validation].promptEmpty)
          }
          continue;
        } 

      }
      return ReturnValueErrors;
    }

  },
  mounted() {
  }

}


// WEBPACK FOOTER //
// ./src/mixins/validation.js